import { render, staticRenderFns } from "./educateDialog.vue?vue&type=template&id=d07faabc&scoped=true"
import script from "./educateDialog.vue?vue&type=script&lang=js"
export * from "./educateDialog.vue?vue&type=script&lang=js"
import style0 from "./educateDialog.vue?vue&type=style&index=0&id=d07faabc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07faabc",
  null
  
)

export default component.exports